import { Link } from 'react-router-dom';

const PostCard = ({ post }) => {
  // 定义本地图片路径（public/images下的文件）
  const localImages = {
    1: `${process.env.PUBLIC_URL}/images/lakers.jpg`,   // 湖人图片
    2: `${process.env.PUBLIC_URL}/images/dong.jpg` ,// 独行侠图片
    3: `${process.env.PUBLIC_URL}/images/jms.jpg`,
    4: `${process.env.PUBLIC_URL}/images/ys.jpg`,
  };

  return (
    <div 
      style={{ 
        marginBottom: 20, 
        borderRadius: 8, 
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)', 
        overflow: 'hidden',
        backgroundColor: '#fff'
      }}
    >
      {/* 引用本地图片 */}
      <img 
        src={localImages[post.id]}  // 根据文章id匹配对应图片
        alt={post.title}
        style={{ 
          width: '100%', 
          height: 200, 
          objectFit: 'cover', // 图片比例不变形
          display: 'block'    // 避免图片下方空白
        }}
        // 图片加载失败时的兜底（可选）
        onError={(e) => {
          e.target.style.backgroundColor = post.id === 1 ? '#FDB927' : '#00538C';
          e.target.style.display = 'flex';
          e.target.style.alignItems = 'center';
          e.target.style.justifyContent = 'center';
          e.target.style.color = 'white';
          e.target.style.fontSize = 24;
          e.target.innerHTML = post.id === 1 ? '湖人' : '独行侠';
        }}
      />
      
      <div style={{ padding: 16 }}>
        <h4 style={{ margin: 0, color: '#333', fontSize: 18 }}>
          <Link to={`/post/${post.id}`} style={{ textDecoration: 'none', color: '#151414ff' }}>
            {post.title}
          </Link>
        </h4>
        <p style={{ 
          marginTop: 8, 
          color: '#666', 
          lineHeight: 1.5,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical'
        }}>
          {post.summary}
        </p>
      </div>
    </div>
  );
};

export default PostCard;